import { render } from "./KRPlacard.vue?vue&type=template&id=75cb487a&scoped=true"
import script from "./KRPlacard.vue?vue&type=script&lang=js"
export * from "./KRPlacard.vue?vue&type=script&lang=js"

import "./KRPlacard.vue?vue&type=style&index=0&id=75cb487a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75cb487a"

export default script